import type { ReviewOfferProduct } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import {
  POWER_MANAGEMENT_PRODUCT_ID,
  PRODUCT_DISPLAY_ORDER,
} from "constants/bundleAndProductIds";

const BATTERY_IDS = new Set<string>(PRODUCT_DISPLAY_ORDER.BATTERIES);
const EV_CHARGER_IDS = new Set<string>(PRODUCT_DISPLAY_ORDER.EV_CHARGER);

const getSimplifiedProductTabLabel = (product: ReviewOfferProduct): string => {
  if (product.productId === PRODUCT_DISPLAY_ORDER.SOLAR) {
    return "Solar Panels";
  }
  if (BATTERY_IDS.has(product.productId)) {
    return product.name?.trim() || "Battery";
  }
  if (EV_CHARGER_IDS.has(product.productId)) {
    return "EV Charger";
  }
  if (product.productId === POWER_MANAGEMENT_PRODUCT_ID) {
    return "SPAN";
  }
  return product.name;
};

export { getSimplifiedProductTabLabel };
